/**
 * 화면별 문서 제목(브라우저 탭) — 경로 패턴 → 제목 한 곳 선언.
 *
 * 탭 제목이 모든 화면에서 "VSMR Editor - Phase 1 MVP" 로 고정돼 화면 구분이 안 됐다
 * (게시판 #23, 2026-09-07). 라우터의 pathless 레이아웃(`DocumentTitle`)이 현재 경로를
 * 이 표에 맞춰 `document.title` 을 갱신한다. 새 화면은 여기 한 줄로 등록한다 —
 * 등록이 없으면 제품명만 남는다(fail-soft, 화면이 깨지지 않는다).
 */
import { SIMULATION_RUN_PATH } from '@/app/routes';
import { matchPath } from 'react-router-dom';

export const PRODUCT_TITLE = 'VSMR';

/** 먼저 맞는 패턴이 이긴다 — 구체적인 경로를 앞에 둔다. */
export const PAGE_TITLES: ReadonlyArray<{ pattern: string; title: string }> = [
  { pattern: '/login', title: '로그인' },
  { pattern: '/signup', title: '회원가입' },
  { pattern: '/', title: '시작' },
  { pattern: '/platform', title: '플랫폼 Overview' },
  { pattern: '/issues', title: '이슈 게시판' },
  { pattern: '/announcements/:number', title: '공지' },
  { pattern: '/announcements', title: '공지' },
  { pattern: '/projects/:projectId/models/:modelId', title: '모델 홈' },
  { pattern: '/projects/:projectId', title: '프로젝트 홈' },
  { pattern: '/projects', title: '프로젝트' },
  { pattern: '/editor', title: 'MARS 에디터' },
  { pattern: '/modelica-editor', title: 'Modelica 에디터' },
  { pattern: SIMULATION_RUN_PATH, title: '시뮬레이션' },
  { pattern: '/simulations', title: '실행 목록' },
  { pattern: '/quickrun', title: '퀵 시뮬레이션' },
  { pattern: '/settings', title: '계정 설정' },
  { pattern: '/tutorial/:tutorialId', title: '튜토리얼' },
  { pattern: '/tutorial', title: '튜토리얼' },
  { pattern: '/operation/*', title: '운전 HMI 이동' },
  { pattern: '/theme-preview', title: '테마 미리보기' },
  { pattern: '/component-demo', title: '컴포넌트 데모' },
];

/** 경로 → "VSMR — 화면명". 등록되지 않은 경로는 제품명만. */
export function documentTitleFor(pathname: string): string {
  const hit = PAGE_TITLES.find((e) => matchPath({ path: e.pattern, end: true }, pathname));
  return hit ? `${PRODUCT_TITLE} — ${hit.title}` : PRODUCT_TITLE;
}
